//  Name: course-congratulations
import EventBus from '@/helpers/event-bus'
import { BLOG_URL, ICON } from '@/config'

export default {
  data () {
    return {
      id: null,
      icon: ICON,
      blog_url: BLOG_URL,
      course: null
    }
  },
  mounted () {
    var vm = this
    vm.id = vm.$route.params.courseId

    vm.$http.post('courses/' + vm.id + '/enroll')
    .then(function (response) {
      let data = response.body
      if (data.status === 'ok') {
        data.course.id = vm.id
        vm.$set(vm, 'course', data.course)
        EventBus.$emit('dismissMessage')
      } else {
        EventBus.$emit('errorMessage', data.message)
      }
    }, function (error) {
      console.error(error)
      EventBus.$emit('errorMessage', 'Ha ocurrido un problema de comunicación con el servidor')
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/course-congratulation/script.js